<template>
  <section id="viewOpenpayFail">
      <big><i class="fa fa-times"></i></big>
      <h1>Ocurrió un error realizando el pago</h1>
  </section>
</template>

<script>
export default {

}
</script>

<style lang="less">
    #viewOpenpayFail {
      text-align: center;
      padding-bottom: 2em;
      min-height: calc(100vh - 580px);
        big {
            font-size: 7em;
            color: #ff006d;
            position: relative;
            top: 0.45em;
        }
        h1 {
          padding: 1em 1em;
        }
    }
</style>